<script>
  import { router } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import FilterCheckbox from '../../components/filter_checkbox.svelte'
  import Paginator from '../../components/paginator.svelte'
  import SearchInput from '../../components/search_input.svelte'
  import { confirm } from '../../components/confirm.js'
  import { Button } from '../../components/ui'

  let {
    places = [],
    total_count = 0,
    pagy = { page: 1, pages: 1, count: 0 },
    filters = {},
    filter_options = {}
  } = $props()

  // `filters` arrives compacted and `filter_options` labelled + narrowed by the server.
  const applyFilters = (changes) => {
    router.get('/places', { ...filters, ...changes }, { preserveState: true, preserveScroll: true })
  }

  const toggleActive = (item, active) => {
    router.patch(`/places/${item.id}/${active ? 'activate' : 'deactivate'}`, {}, { preserveScroll: true })
  }

  const archive = async (item) => {
    const confirmed = await confirm({
      title: 'Confirm Archive',
      variant: 'error',
      body: 'Archiving is permanent unless reversed by a developer. Are you sure?'
    })
    if (!confirmed) return
    router.delete(`/places/${item.id}`, { preserveScroll: true })
  }
</script>

<Layout>
  <PageHeader title="Places" subtitle="Check-in venues within each college town" count={pagy.count} total={total_count}>
    {#snippet actions()}
      <Button href="/places/new" variant="primary" size="sm" icon="add">New Place</Button>
    {/snippet}
  </PageHeader>

  <FilterBar>
    {#snippet start()}
      <SearchInput value={filters.search || ''} param="search" placeholder="Search places…" />

      <FilterSelect
        label="Category"
        value={filters.category_id || ''}
        placeholder="All categories"
        options={filter_options.categories ?? []}
        onchange={(v) => applyFilters({ category_id: v || undefined, sub_category_id: undefined })}
      />

      <FilterSelect
        label="Sub Category"
        value={filters.sub_category_id || ''}
        placeholder="All sub categories"
        options={filter_options.sub_categories ?? []}
        onchange={(v) => applyFilters({ sub_category_id: v || undefined })}
      />

      <FilterCheckbox label="Check-in" checked={filters.checkin_enabled} onchange={(v) => applyFilters({ checkin_enabled: v || undefined })} />
      <FilterCheckbox label="Official Partner" checked={filters.official_partner} onchange={(v) => applyFilters({ official_partner: v || undefined })} />
    {/snippet}
  </FilterBar>

  <EntityList entity="place" rows={places} onToggle={toggleActive} onDelete={archive} />

  <Paginator {...pagy} />
</Layout>
